import TreatmentFullLayout from "../../components/TreatmentLayout";
import Service4 from "../../assets/images/service/04.jpg";

import ImgEndo from "../../assets/images/service_detail/endourology/01.jpg";
import ImgLaser from "../../assets/images/service_detail/endourology/02.jpg";
import ImgURS from "../../assets/images/service_detail/endourology/03.jpg";
import ImgPCNL from "../../assets/images/service_detail/endourology/04.jpg";

const EndourologyData = () => {

const data = {
title:"Endourology Treatment",
subtitle:"Advanced minimally invasive urology procedures",

heading:"Best Endourology Treatment",
description:"Endourology is an advanced branch of urology that uses minimally invasive techniques to treat urinary tract disorders such as kidney stones, tumors and prostate issues without open surgery.",

image:Service4,

sections:[

{
title:"What is Endourology Treatment?",
content:"Endourology is an advanced and minimally invasive branch of urology that focuses on diagnosing and treating urinary tract problems using small cameras and specialized instruments without open surgery. It is widely used for kidney stones, prostate problems, bladder issues and ureter conditions. At BBMH (Brijesh Banger Memorial Hospital), Dr. Sachitanand Chaurasia provides advanced endourology treatment using modern laser technology ensuring safe, painless and highly effective results for patients.",
image: ImgEndo
},

{
title:"Common Endourology Procedures",
content:"Endourology involves advanced minimally invasive procedures performed using small cameras, endoscopes and laser technology to treat urinary tract problems without open surgery. These procedures provide safe treatment, minimal pain and faster recovery for patients.",
list:[
"RIRS (Retrograde Intrarenal Surgery) – Laser treatment for kidney stones without any external cut.",
"Ureteroscopy (URS) – Endoscopic removal of stones from ureter using laser technology.",
"PCNL / Mini PCNL – Minimally invasive surgery for large or complex kidney stones.",
"TURP – Endoscopic surgery for enlarged prostate causing urine blockage.",
"Cystoscopy – Camera examination of bladder and urinary tract for diagnosis.",
"Bladder Stone Removal – Endoscopic removal of bladder stones using laser or instruments.",
"TURBT – Endoscopic removal of bladder tumors for diagnosis and treatment.",
"Ureter & Kidney Obstruction Treatment – Procedures to remove blockage in urinary tract.",
"Endopyelotomy – Treatment for PUJ obstruction using endoscopic techniques.",
"Ureteroscopic Biopsy – Tissue sampling for diagnosis of tumors or strictures.",
"Laser VIU – Laser treatment for urethral stricture to improve urine flow.",
"Ureterocele Incision – Correction of ureterocele to restore normal urine flow.",
"Percutaneous Nephrostomy – Tube placement to drain urine from blocked kidney.",
"USG Guided Prostate Biopsy – Ultrasound-guided biopsy for prostate evaluation.",
"AV Fistula Creation – Surgical access creation for dialysis in kidney failure patients."
]
},

{
title:"Laser Lithotripsy for Kidney Stones",
content:"Laser lithotripsy is a modern and highly effective endourology procedure used to break kidney or ureter stones into fine particles using high-energy laser. The procedure is performed through natural urinary passage without any external incision, ensuring minimal pain, faster recovery and high success rate. Most patients can return home within 24 hours.",
image: ImgLaser
},

{
title:"Ureteroscopy (URS)",
content:"Ureteroscopy is a minimally invasive procedure in which a thin flexible scope is passed through urinary passage to locate stones in ureter or kidney. Laser is used to break larger stones into smaller pieces which are removed safely. This procedure does not require any external cut and allows quick recovery with minimal discomfort.",
image: ImgURS
},

{
title:"PCNL for Large Kidney Stones",
content:"Percutaneous Nephrolithotomy (PCNL) is recommended for large or complex kidney stones that cannot be treated with simple procedures. A small incision is made in the back and specialized instruments are used to remove stones completely. PCNL provides high success rate and long-term relief for large stone cases.",
image: ImgPCNL
},

{
title:"Benefits of Endourology Treatment",
content:"Endourology procedures provide advanced and patient-friendly treatment options compared to traditional open surgery. These modern techniques ensure better outcomes and faster healing.",
list:[
"Minimally invasive procedures with no large cuts",
"Less pain and minimal bleeding",
"Faster recovery and early discharge",
"Short hospital stay",
"High success and safety rate",
"Minimal scars and better cosmetic results",
"Quick return to normal daily activities"
]
},

{
title:"Recovery After Endourology Procedures",
content:"Recovery after endourology procedures is usually quick and smooth. Most patients can resume daily activities within a few days. Doctors advise adequate water intake, prescribed medications, proper hygiene and regular follow-up visits to ensure complete recovery and prevent recurrence of stones or urinary problems."
},

{
title:"Why Choose Dr. Sachitanand Chaurasia for Endourology Treatment?",
content:"Dr. Sachitanand Chaurasia is a trusted and experienced urologist known for advanced endourology treatments. At BBMH (Brijesh Banger Memorial Hospital), patients receive modern operation theatre facilities, latest laser machines and complete pre & post treatment care. The focus is on safe procedures, quick recovery and best patient outcomes."
}

],

faq:[
{q:"Is endourology surgery painful?",a:"No, it is minimally invasive and mostly painless."},
{q:"Recovery time?",a:"Usually 2-5 days depending on procedure."},
{q:"Is it safe?",a:"Yes, it is one of the safest urology treatments."}
]
};

return <TreatmentFullLayout data={data}/>
};

export default EndourologyData;